import React from 'react';
import { SETTLEMENTS } from '../../data/mockData';
import { Download, FileText } from 'lucide-react';
export function Settlement() {
  return <div className="max-w-6xl mx-auto space-y-6" data-id="element-856">
      <div className="flex items-center justify-between" data-id="element-857">
        <h1 className="text-2xl font-semibold text-bone" data-id="element-858">Settlement</h1>
        <button className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-ink-3 border border-white/10 text-sm font-medium text-bone hover:bg-ink-4 transition-colors" data-id="element-859">
          <Download className="w-4 h-4" data-id="element-860" />
          Download All
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-861">
        <div className="bg-ink-2 border border-white/5 rounded-2xl p-5" data-id="element-862">
          <div className="text-sm font-medium text-muted mb-1" data-id="element-863">
            Next Settlement
          </div>
          <div className="text-2xl font-semibold text-bone" data-id="element-864">R 12,450.00</div>
          <div className="text-xs text-mint mt-1" data-id="element-865">Expected today, 17:00</div>
        </div>
        <div className="bg-ink-2 border border-white/5 rounded-2xl p-5" data-id="element-866">
          <div className="text-sm font-medium text-muted mb-1" data-id="element-867">
            Settled (MTD)
          </div>
          <div className="text-2xl font-semibold text-bone" data-id="element-868">R 177,461.50</div>
          <div className="text-xs text-muted mt-1" data-id="element-869">June 1 - Present</div>
        </div>
        <div className="bg-ink-2 border border-white/5 rounded-2xl p-5" data-id="element-870">
          <div className="text-sm font-medium text-muted mb-1" data-id="element-871">
            Settlement Account
          </div>
          <div className="text-lg font-medium text-bone" data-id="element-872">Standard Bank</div>
          <div className="text-xs text-muted mono mt-1" data-id="element-873">**** **** 4421</div>
        </div>
      </div>

      <div className="bg-ink-2 border border-white/5 rounded-2xl overflow-hidden" data-id="element-874">
        <div className="px-6 py-4 border-b border-white/5" data-id="element-875">
          <h2 className="text-lg font-medium text-bone" data-id="element-876">Recent Batches</h2>
        </div>
        <div className="overflow-x-auto" data-id="element-877">
          <table className="w-full text-left text-sm" data-id="element-878">
            <thead className="bg-ink text-muted uppercase tracking-wider text-xs" data-id="element-879">
              <tr data-id="element-880">
                <th className="px-6 py-4 font-medium" data-id="element-881">Date</th>
                <th className="px-6 py-4 font-medium" data-id="element-882">Batch Ref</th>
                <th className="px-6 py-4 font-medium" data-id="element-883">Transactions</th>
                <th className="px-6 py-4 font-medium" data-id="element-884">Amount</th>
                <th className="px-6 py-4 font-medium" data-id="element-885">Status</th>
                <th className="px-6 py-4 font-medium text-right" data-id="element-886">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/5" data-id="element-887">
              {SETTLEMENTS.map(batch => <tr key={batch.id} className="hover:bg-ink-3/50 transition-colors" data-id="element-888">
                
                  <td className="px-6 py-4 text-bone" data-id="element-889">
                    {new Date(batch.date).toLocaleDateString()}
                  </td>
                  <td className="px-6 py-4 mono text-bone-dim" data-id="element-890">
                    {batch.batchRef}
                  </td>
                  <td className="px-6 py-4 text-muted" data-id="element-891">{batch.count}</td>
                  <td className="px-6 py-4 font-medium text-bone" data-id="element-892">
                    R {batch.amount.toFixed(2)}
                  </td>
                  <td className="px-6 py-4" data-id="element-893">
                    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${batch.status === 'completed' ? 'bg-mint/10 text-mint' : 'bg-yellow-500/10 text-yellow-500'}`} data-id="element-894">
                    
                      {batch.status.charAt(0).toUpperCase() + batch.status.slice(1)}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-895">
                    <button className="p-2 text-muted hover:text-bone transition-colors" title="Download Recon File" data-id="element-896">
                    
                      <FileText className="w-4 h-4" data-id="element-897" />
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}